'use client';
import { useState } from 'react';

var useMutation = function(requester, handlers, options) {
    var _ref = options || {}, _ref_initialLoading = _ref.initialLoading, initialLoading = _ref_initialLoading === void 0 ? false : _ref_initialLoading;
    var _ref1 = handlers || {}, onSuccess = _ref1.onSuccess, onError = _ref1.onError, onFinish = _ref1.onFinish;
    var _useState = useState(initialLoading), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = useState(null), error = _useState1[0], setError = _useState1[1];
    var _useState2 = useState(null), data = _useState2[0], setData = _useState2[1];
    var handleSuccess = function(data) {
        setError(null);
        onSuccess == null ? void 0 : onSuccess(data);
        setData(data);
    };
    var handleError = function(error) {
        onError == null ? void 0 : onError(error);
        setError(error);
    };
    var handleFinish = function() {
        onFinish == null ? void 0 : onFinish();
        setLoading(false);
    };
    var mutate = function() {
        setLoading(true);
        requester().then(handleSuccess).catch(handleError).finally(handleFinish);
    };
    var reset = function() {
        setLoading(initialLoading);
        setError(null);
        setData(null);
    };
    return {
        data: data,
        loading: loading,
        error: error,
        mutate: mutate,
        reset: reset
    };
};

export { useMutation };
